import { render, staticRenderFns } from "./RyuryoChart.vue?vue&type=template&id=b5a66e32&scoped=true"
import script from "./RyuryoChart.vue?vue&type=script&lang=ts"
export * from "./RyuryoChart.vue?vue&type=script&lang=ts"
import style0 from "./RyuryoChart.vue?vue&type=style&index=0&id=b5a66e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a66e32",
  null
  
)

export default component.exports